import { DefaultNamespace, UseTranslationResponse } from 'react-i18next'

import { DiscountType, DiscountUnitType } from '../../@types'
import { PromoCodeErrorCodes } from '../../components/PromoCode/types'
import { CartPrice, DiscountPrice } from '../../hooks/use-cart-price'
import { PlaceOrderInput } from '../payment'

export const shouldBypassPaymentGateway = (cartPrice: CartPrice) => {
  return isPercentageDiscount(cartPrice) && (cartPrice as DiscountPrice).discount.value === 100
}

export const isPercentageDiscount = (cartPrice: CartPrice) => {
  const discount = (cartPrice as DiscountPrice)?.discount

  return discount?.unitType === DiscountUnitType.PERCENTAGE
}

export const getPlaceOrderDiscountParameters = (
  cartPrice: CartPrice
): Pick<PlaceOrderInput, 'promoCode' | 'referralCode' | 'discountName'> => {
  if (!isPercentageDiscount(cartPrice)) return {}

  const { code, name, type } = (cartPrice as DiscountPrice).discount

  if (type === DiscountType.PROMO_CODE) {
    return {
      promoCode: code,
      discountName: name,
    }
  }
  if (type === DiscountType.REFERRAL) {
    return {
      referralCode: code,
      discountName: name,
    }
  }

  return {}
}

export const getPromoCodeErrorMessage = (
  t: UseTranslationResponse<DefaultNamespace>['t'],
  errorCode?: PromoCodeErrorCodes
) => {
  const errorMessages = {
    [PromoCodeErrorCodes.ALREADY_USED]: t('screens.checkout.promoCode.validations.invalid'),
    [PromoCodeErrorCodes.DATE_RANGE]: t('screens.checkout.promoCode.validations.dateRange'),
    [PromoCodeErrorCodes.INVALID_PRODUCT]: t('screens.checkout.promoCode.validations.invalid'),
    [PromoCodeErrorCodes.LIMIT_USAGE]: t('screens.checkout.promoCode.validations.limitUsage'),
    [PromoCodeErrorCodes.PAYMENT_GATEWAY_THRESHOLD]: t('screens.checkout.promoCode.validations.threshold'),
    [PromoCodeErrorCodes.PROMOCODE_DISABLED]: t('screens.checkout.promoCode.validations.disabled'),
    [PromoCodeErrorCodes.TOO_MANY_CODES]: t('screens.checkout.promoCode.validations.invalid'),
    [PromoCodeErrorCodes.INCOMPATIBLE_WITH_COMPANY_DISCOUNT]: t('screens.checkout.promoCode.validations.incompatible'),
  }

  return errorCode ? errorMessages[errorCode] : null
}
